import React from "react";
import { EditButton, useShowController } from "react-admin";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { DealIcon } from "../svg/DealIcon";

import { useCanEditOffer } from "../hooks/useCanEditOffer";
import { ShowToolbar } from "./ShowToolbar";

const commonStyles = {
  toolbar: {
    textAlign: "right",
  },
  loading: {
    display: "inline-block",
    verticalAlign: "middle",
  },
  button: (theme: any) => ({
    marginLeft: theme.spacing(2),
  }),
  dealListButton: {
    color: "rgb(30, 136, 229)",
    "&:hover": {
      backgroundColor: "rgb(30, 136, 229, 0.12)",
    },
  },
};

export const OfferShowActions = (props: { listPath: string; permissions: string }) => {
  const { listPath, permissions, ...actionProps } = props;
  const { resource, record } = useShowController();
  const [isLoading, canEdit] = useCanEditOffer(permissions, record);

  if (!permissions || !record) {
    return null;
  }

  return (
    <ShowToolbar {...actionProps} listPath={listPath}>
      <Box sx={commonStyles.toolbar}>
        {isLoading && (
          <Box component="span" sx={commonStyles.loading}>
            <CircularProgress size={16} />
          </Box>
        )}
        {canEdit && (
          <Box component="span" sx={commonStyles.button}>
            <EditButton resource={resource} record={record} />
          </Box>
        )}
        <Box component="span" sx={commonStyles.button}>
          <DealListButton offerId={record.id} />
        </Box>
      </Box>
    </ShowToolbar>
  );
};

type ButtonProps = {
  offerId: number;
};

export const DealListButton = (props: ButtonProps) => {
  const displayFilters = {
    offer_id: true,
  };
  const filter = {
    offer_id: props.offerId,
  };
  const toString = (obj: any) => encodeURIComponent(JSON.stringify(obj));
  const to = `/#/deals?displayFilters=${toString(displayFilters)}&filter=${toString(filter)}`;

  return (
    <Button
      sx={commonStyles.dealListButton}
      size="small"
      startIcon={<DealIcon width={18} height={13.65} color="#1e88e5" />}
      href={to}
    >
      取引案件
    </Button>
  );
};
